import { Stack, useTheme } from "@mui/material";
import { type FC, Fragment } from "react";
import type { IdentificationDocumentListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PaperworkDocumentRow } from "web_myplann/Profile/Components/Paperwork/PaperworkDocumentRow";
import { ProfileSection } from "web_myplann/Profile/Components/ProfileSection";

const R = Resources.Paperwork;

type Props = {
	documents: IdentificationDocumentListItemResponseDTO[];
};

export const PaperworkDocumentList: FC<Props> = ({ documents }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<ProfileSection title={t(R.uploadedSection)}>
			{documents.map((document, index) => (
				<Fragment key={document.id}>
					{index > 0 && (
						<Stack ml={7} borderTop={1} borderColor={theme.palette.grey[100]} />
					)}
					<PaperworkDocumentRow document={document} />
				</Fragment>
			))}
		</ProfileSection>
	);
};
